/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcommerceOrderSyncResponseVo
 */
export interface EcommerceOrderSyncResponseVo {
    /**
     * 本次查询窗口内所有分页和落库是否全部成功。
     * @type {boolean}
     * @memberof EcommerceOrderSyncResponseVo
     */
    success?: boolean;
    /**
     * 本次同步日志ID。
     * @type {number}
     * @memberof EcommerceOrderSyncResponseVo
     */
    syncLogId?: number;
    /**
     * 向平台查询的业务时间窗口起点。
     * @type {string}
     * @memberof EcommerceOrderSyncResponseVo
     */
    queryStartTime?: string;
    /**
     * 向平台查询的业务时间窗口终点。
     * @type {string}
     * @memberof EcommerceOrderSyncResponseVo
     */
    queryEndTime?: string;
    /**
     * 平台API实际返回的履约订单数量，包含重复订单。
     * @type {number}
     * @memberof EcommerceOrderSyncResponseVo
     */
    fetchCount?: number;
    /**
     * 本次成功完成新增或刷新落库的履约订单数量。
     * @type {number}
     * @memberof EcommerceOrderSyncResponseVo
     */
    successCount?: number;
    /**
     * 拉取或落库失败的数量。
     * @type {number}
     * @memberof EcommerceOrderSyncResponseVo
     */
    failCount?: number;
    /**
     * 同步结果说明。
     * @type {string}
     * @memberof EcommerceOrderSyncResponseVo
     */
    message?: string;
}

/**
 * Check if a given object implements the EcommerceOrderSyncResponseVo interface.
 */
export function instanceOfEcommerceOrderSyncResponseVo(value: object): value is EcommerceOrderSyncResponseVo {
    return true;
}

export function EcommerceOrderSyncResponseVoFromJSON(json: any): EcommerceOrderSyncResponseVo {
    return EcommerceOrderSyncResponseVoFromJSONTyped(json, false);
}

export function EcommerceOrderSyncResponseVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcommerceOrderSyncResponseVo {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'syncLogId': json['syncLogId'] == null ? undefined : json['syncLogId'],
        'queryStartTime': json['queryStartTime'] == null ? undefined : json['queryStartTime'],
        'queryEndTime': json['queryEndTime'] == null ? undefined : json['queryEndTime'],
        'fetchCount': json['fetchCount'] == null ? undefined : json['fetchCount'],
        'successCount': json['successCount'] == null ? undefined : json['successCount'],
        'failCount': json['failCount'] == null ? undefined : json['failCount'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function EcommerceOrderSyncResponseVoToJSON(json: any): EcommerceOrderSyncResponseVo {
    return EcommerceOrderSyncResponseVoToJSONTyped(json, false);
}

export function EcommerceOrderSyncResponseVoToJSONTyped(value?: EcommerceOrderSyncResponseVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'syncLogId': value['syncLogId'],
        'queryStartTime': value['queryStartTime'],
        'queryEndTime': value['queryEndTime'],
        'fetchCount': value['fetchCount'],
        'successCount': value['successCount'],
        'failCount': value['failCount'],
        'message': value['message'],
    };
}

